import { useLazyGetDealerListQuery } from '@api/customer.api';
import { useAppSelector } from '@hooks';
import { getTableBlockData } from '@store/table/table.slice';
import { useCallback } from 'react';

type DealerListProps = {
  id: string;
  itemsPerPage: number;
};

export const useDealerList = ({ id, itemsPerPage }: DealerListProps) => {
  const { filters, offset } = useAppSelector(getTableBlockData(id)) as {
    filters: {
      Search?: string;
    };
    offset: number;
  };
  const [trigger, response] = useLazyGetDealerListQuery();
  const fetchDealers = useCallback(() => {
    const requestFilters = [
      {
        filterName: 'SearchByName',
        value: filters?.Search || '',
      },
    ];

    trigger({ offSet: offset, limit: itemsPerPage, filters: requestFilters, includeUsers: true, includeOrders: true });
  }, [filters, offset, itemsPerPage, trigger]);

  return { fetchDealers, response, offset, filters };
};
